var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"px-0",staticStyle:{"color":"#173466"},attrs:{"text":""},on:{"click":_vm.goBack}},[_c('v-icon',{attrs:{"size":"x-large"}},[_vm._v("mdi-chevron-left")]),_c('span',{staticClass:"text-body-1"},[_vm._v(_vm._s(_vm.$t("downloadView.returToPrevious")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }